<template>
  <Transition>
    <div
      class="fixed inset-0 z-40 bg-black/50 flex flex-col items-center p-3 sm:p-5 md:p-10 overflow-y-scroll"
      @click.self="closeModal"
    >
      <div class="md:flex-1"></div>
      <div
        class="block container max-w-5xl rounded-lg pt-6 pb-8 md:pt-8 md:pb-16 shadow-lg"
        :class="[bgClass]"
      >
        <div class="px-5 sm:px-10 flex justify-end md:mb-2">
          <button @click="closeModal" @keydown.enter="closeModal">
            <!-- <FontAwesome class="text-4xl text-los-blue-darkest" icon="times" /> -->
            <svg
              id="Laag_1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1050.58 1329.95"
              class="h-6 w-6 md:h-10 md:w-10 fill-los-blue-darkest"
            >
              <rect
                x="-78.63"
                y="852.58"
                width="651.81"
                height="114.9"
                rx="57.45"
                ry="57.45"
                transform="translate(-571.06 441.39) rotate(-45)"
              />
              <rect
                x="710.28"
                y="584.12"
                width="114.9"
                height="651.81"
                rx="57.45"
                ry="57.45"
                transform="translate(-418.63 809.4) rotate(-45)"
              />
              <rect
                x="189.83"
                y="63.67"
                width="114.9"
                height="651.81"
                rx="57.45"
                ry="57.45"
                transform="translate(-203.05 288.96) rotate(-45)"
              />
              <rect
                x="441.82"
                y="332.13"
                width="651.81"
                height="114.9"
                rx="57.45"
                ry="57.45"
                transform="translate(-50.61 656.97) rotate(-45)"
              />
            </svg>
          </button>
        </div>
        <div class="mx-auto px-basic">
          <slot></slot>
        </div>
      </div>
      <div class="md:flex-1"></div>
    </div>
  </Transition>
</template>

<script setup>
const emit = defineEmits(['close']);

function closeModal() {
  emit('close');
}

defineProps({
  bgClass: {
    type: String,
    default: 'bg-white',
  },
});

onMounted(() => {
  useHead({
    bodyAttrs: {
      class: 'overflow-hidden',
    },
  });
});

onBeforeUnmount(() => {
  useHead({
    bodyAttrs: {
      class: '',
    },
  });
});
</script>

<style lang="scss" scoped></style>
